import { render, staticRenderFns } from "./Plane.vue?vue&type=template&id=2ea632df&"
import script from "./Plane.vue?vue&type=script&lang=ts&"
export * from "./Plane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports